import { render, staticRenderFns } from "./PaymentChoiceItem.vue?vue&type=template&id=29cd6dea&scoped=true"
import script from "./PaymentChoiceItem.vue?vue&type=script&lang=js"
export * from "./PaymentChoiceItem.vue?vue&type=script&lang=js"
import style0 from "./PaymentChoiceItem.vue?vue&type=style&index=0&id=29cd6dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cd6dea",
  null
  
)

export default component.exports